import { useState, useEffect } from 'react'
import { useSearchParams, useLocation, useNavigate } from 'react-router'
import { useTranslation } from 'react-i18next'
import { Icon } from '../icon/icon'
import { useUserQueries } from '~/utils/queries/userUrlQueries'

export default function SearchBoxSearchField() {
	const { t } = useTranslation()
	const navigate = useNavigate()
	const location = useLocation()
	const { searchText } = useUserQueries()

	const [searchParams] = useSearchParams()
	const [search, setSearch] = useState(searchText || '')

	function handleSearch(e: React.KeyboardEvent<HTMLInputElement>) {
		if (e.key === 'Enter') {
			const query = e.currentTarget.value
			setSearch(query)

			const sp = new URLSearchParams(searchParams.toString())
			sp.delete('page')
			sp.delete('city')
			sp.delete('country')

			if (query === '') {
				sp.delete('s')
			} else {
				sp.set('s', query)
			}
			navigate(`${`${location?.pathname ?? ''}`}?${sp.toString()}`)
		}
	}

	useEffect(() => {
		const query = searchParams.get('s') || ''
		setSearch(query)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [searchText])
	function handleClear() {
		setSearch('')
		const sp = new URLSearchParams(searchParams.toString())
		sp.delete('s')
		navigate(`${location?.pathname ?? ''}?${sp.toString()}`)
	}

	return (
		<div className="relative flex items-center">
			<input
				type="text"
				placeholder={t('action_search_for_event')}
				className="bg-card border-border hover:border-foreground/50 w-full rounded-t-3xl rounded-b-none border px-6 py-2.5 text-lg font-medium shadow-md backdrop-blur-md"
				onKeyDown={handleSearch}
				onChange={e => setSearch(e.target.value)}
				value={search}
				aria-label={t('action_search_for_event')}
			/>
			{search ? (
				<button
					onClick={handleClear}
					className="text-foreground/50 hover:text-foreground absolute top-1/2 right-6 -translate-y-1/2"
					aria-label="Clear search"
				>
					<Icon name="cross" className="cursor-pointer" />
				</button>
			) : (
				<Icon
					name="search"
					className="text-foreground/50 absolute top-1/2 right-6 -translate-y-1/2"
				/>
			)}
		</div>
	)
}
